import { connect, useDispatch, useSelector } from "react-redux";
import { AppState, useAppSelector } from "../../RootReducer";
import { Dispatch } from "redux";
import React from "react";
import { initWithdraw } from "../../payments/WithdrawActions";
import { CurrencyDefinition, PaymentMethod, WithdrawContext } from "../../http/protocol";
import "../Withdraw.scss"
import { t } from "../../i18n";
import { WithdrawState, WithdrawStateStatus } from "../../payments/PaymentsReducer";
import { BrandA } from "../buttons/buttons";
import { PriorityType } from "../../http/Types";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import { Big } from "big.js";
import { get } from "js-cookie";
import { getCurrencyDefinitions, getPreferredFiatExchange } from "../../selectors/settings-selectors";
import { hasFiatExchangeAmount, toFiatAmount } from "../../currency/currency-utils";

interface Props {
  updateAddress?: (recipientAddress: string) => void;
  initWithdraw?: () => void;
  recipientAddress?: string;
  amount?: string;
  currency?: string;
  confirmedStatus?: boolean;
  currencies?: Array<CurrencyDefinition>;
  activeMethod?: PaymentMethod;
  withdraw: WithdrawState;
  withdrawContext: WithdrawContext;
  priority: PriorityType;
  orderCustom?: any;
  destinationTag?: string;
  status: WithdrawStateStatus;
  preferredExchangeCurrency: string;
  currencyDefinitions: CurrencyDefinition[];
}

interface State {
  withdrawalConfirmed: boolean
}

export class ConfirmWithdraw extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { withdrawalConfirmed: false };
  }

  toggleWithdrawConfirmed() {
    this.setState({
      withdrawalConfirmed: !this.state.withdrawalConfirmed,
    });
  }

  getCurrency() {
    let currency =
      this.props.currencies &&
      this.props.currencies.find((currencyDef: CurrencyDefinition) => {
        if (this.props && this.props.currency && currencyDef.code == this.props.currency) {
          return true;
        }
      });
    return currency;
  }

  balanceToFiatAmount() {
    return toFiatAmount(this.getCurrency()?.code || "EUR", parseFloat(this.props.amount || "0"), this.props.preferredExchangeCurrency, this.props.currencyDefinitions);
  }

  render() {
    let wc = this.props.withdrawContext;
    /*     debugger */
    let inputs = wc?.inputs ?? wc?.customContext?.input ?? undefined;

    console.log(this.props.orderCustom, wc.customContext);
    return (
      <div className={"confirm-withdraw-container"}>

        <div className={"withdraw-summary"}>
          <div className={"payout"}>
            {this.props.orderCustom &&
              inputs &&
              inputs.map((i: any) => (
                <div className={"amountContainer"}>
                  <span className={"amountLabel"}>{t(`payment.form.${i.name}.confirm-label`)}</span>
                  <div className="amount-box">
                    {i.type == "SELECT" && <span className={"amount"}>{t(`payment.form.${i.name}.opt-${this.props.orderCustom[i.name]}`)}</span>}
                    {i.type != "SELECT" && <span className={"amount"}>{this.props.orderCustom[i.name]}</span>}
                  </div>
                </div>
              ))


            }
            {(!inputs || inputs.length == 0) && (
              <>
                {/* ------ */}
                <div className={"amountContainer"}>
                  <span className={"amountLabel"}>{t("withdrawPage.withdrawCurrency")}</span>
                  <div className="amount-box">
                    <CurrencyIcon currency={this.getCurrency()?.code || ""} />
                    <span className={"amount"}>{this.getCurrency()?.code || ""}</span>
                  </div>
                </div>
                {/* ------ */}
                {this.props.activeMethod?.displayName && (
                  <div className={"amountContainer"}>
                    <span className={"amountLabel"}>{t("withdrawPage.withdrawMethod")}</span>
                    <div className="amount-box">
                      <CurrencyIcon currency={this.getCurrency()?.code || ""} />
                      <span className={"amount"}>{this.props.activeMethod?.displayName || ""}</span>
                    </div>
                  </div>
                )}
                {/* ------ */}
                {wc?.cryptoContext?.networkName && (
                  <div className={"amountContainer"}>
                    <span className={"amountLabel"}>{t("withdrawPage.withdrawNetwork")}</span>
                    <div className="amount-box">
                      <span className={"amount"}>{wc?.cryptoContext?.networkName || ""}</span>
                    </div>
                  </div>
                )}
                {/* ------ */}
                {this.props.recipientAddress && (
                  <div className={"amountContainer"}>
                    <span className={"amountLabel"}>{t("payments.account")}</span>
                    <div className="amount-box">
                      <span className={"amount"}>{this.props.recipientAddress || ""}</span>
                    </div>
                  </div>
                )}
                {/* ------ */}
                {this.props.destinationTag && this.props.destinationTag.length > 0 && (
                  <div className={"amountContainer"}>
                    <span className={"amountLabel"}>{t("payments.destination-tag")}</span>
                    <div className="amount-box">
                      <span className={"amount"}>{this.props.destinationTag || ""}</span>
                    </div>
                  </div>
                )}
                {/* ------ */}
                {this.props.priority && (
                  <div className={"amountContainer"}>
                    <span className={"amountLabel"}>{t("withdraw.networkPriority")}</span>
                    <div className="amount-box">
                      <span className={"amount"}>{t("withdraw." + this.props.priority, { fee: CurrencyFormatter.formatWithSymbol(this.getCurrency(), wc?.cryptoContext?.fees?.priority?.[this.props.priority]) })}</span>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className={"amountContainer"}>
              <div className="amount-fiat-box">
                <span className={"amountLabel"}>{t("withdrawPage.verifyPhaseText1")}</span>
                {this.getCurrency()?.code && hasFiatExchangeAmount(this.getCurrency()?.code || '', this.props.preferredExchangeCurrency, this.props.currencyDefinitions) && (
                  <span className={"amountFiatLabel"}>{this.balanceToFiatAmount()}</span>
                )}
              </div>
              <div>
                <div className="amount-box">
                  <CurrencyIcon currency={this.getCurrency()?.code || ""} />
                  <span className={"amount"}>{this.props.amount && CurrencyFormatter.formatWithSymbol(this.getCurrency(), new Big(this.props.amount))}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={"summaryContainer checkbox"}>
          {this.state.withdrawalConfirmed && (
            <span onClick={() => this.toggleWithdrawConfirmed()} className="material-icons">
              check_box
            </span>
          )}
          {!this.state.withdrawalConfirmed && (
            <span onClick={() => this.toggleWithdrawConfirmed()} className="material-icons">
              check_box_outline_blank
            </span>
          )}
          <span className={"summary-text"} onClick={() => this.toggleWithdrawConfirmed()}>
            {t("withdrawPage.verifyPhaseText3")}
          </span>
        </div>
        <div className="withdraw-summery-button-container">
          <BrandA className={"btn btn-cta"} onClick={() => this.props.initWithdraw && this.props.initWithdraw()} disabled={!this.state.withdrawalConfirmed || this.props.status === WithdrawStateStatus.WITHDRAW_INITIATED}>
            {t("withdrawPage.withdrawRequestAction")}
          </BrandA>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (app: AppState) => {
  return {
    withdraw: app.payments.withdraw,
    status: app.payments.withdraw.status,
    activeMethod: app.payments.withdraw.activeMethod,
    currency: app.payments.withdraw.activeCurrency,
    amount: app.payments.withdraw.amount,
    recipientAddress: app.payments.withdraw.recipientAddress,
    destinationTag: app.payments.withdraw.destinationTag,
    notesTag: app.payments.withdraw.notesTag,
    currencies: app.user.user != undefined ? app.user.user.currencies : undefined,
    withdrawContext: app.payments.withdraw.withdrawContext,
    priority: app.payments.withdraw.priority,
    orderCustom: app.payments.withdraw.orderCustom,
    preferredExchangeCurrency: getPreferredFiatExchange(app),
    currencyDefinitions: getCurrencyDefinitions(app),

  };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  initWithdraw: () => dispatch(initWithdraw() as any)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmWithdraw as any);



const CurrencyIcon = ({ currency }: { currency: string }) => {
  return (
    <div className={"currency-icon-container"}>
      <i className={"currency-icon currency-icon-" + currency.toLocaleLowerCase()}></i>
    </div>
  )
}